module.exports = __webpack_public_path__ + "static/media/group.98d74358.svg";